export function countWorkHours(start: string, end: string, holidays: Map<string, string>, type: 'five' | 'six') {
    const s = new Date(start);
    const e = new Date(end);
    const cur = new Date(s);
    let hours = 0;

    const holidaySet = new Set<string>();
    for (const [hDate] of holidays) {
      if (hDate >= start && hDate <= end) holidaySet.add(hDate);
    }

    while (cur <= e) {
      const day = cur.getDay();
      const dateStr = cur.toISOString().slice(0, 10);

      if (!holidaySet.has(dateStr)) {
        if (type === 'five' && day >= 1 && day <= 5) {
          let daily = 8;
          const next = new Date(cur);
          next.setDate(cur.getDate() + 1);
          if (holidaySet.has(next.toISOString().slice(0, 10))) daily -= 1;
          hours += daily;
        } else if (type === 'six') {
          if (day >= 1 && day <= 5) {
            let daily = 7;
            const next = new Date(cur);
            next.setDate(cur.getDate() + 1);
            if (holidaySet.has(next.toISOString().slice(0, 10))) daily -= 1;
            hours += daily;
          } else if (day === 6) {
            hours += 5;
          }
        }
      }

      cur.setDate(cur.getDate() + 1);
    }

    return hours;
  }